import React from 'react'
import styles from './styles.module.scss'

interface ProcessSectionProps {
    onScrollToForm: () => void
}

export const ProcessSection: React.FC<ProcessSectionProps> = ({ onScrollToForm }) => {
    return (
        <section className={styles.processSection}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <h2>Our Simple 3-Step Process</h2>
                    <p>
                        We specialise in affordability claims and handle everything for you. Our experienced team
                        communicates with lenders and the Ombudsman service on your behalf, using smart technology to
                        track your progress at every stage.
                    </p>
                </div>
                <div className={styles.processSteps}>
                    <div className={styles.step}>
                        <div className={styles.stepNumber}>1</div>
                        <div className={styles.stepContent}>
                            <h3>Free Assessment</h3>
                            <p>
                                Complete our form and securely connect your bank accounts via open banking. We'll
                                analyze your financial situation and assess your case for free.
                            </p>
                        </div>
                    </div>
                    <div className={styles.step}>
                        <div className={styles.stepNumber}>2</div>
                        <div className={styles.stepContent}>
                            <h3>Submit Complaint</h3>
                            <p>
                                Our legal experts submit a formal complaint to your lender with all the evidence. We
                                handle all communication and negotiations on your behalf.
                            </p>
                        </div>
                    </div>
                    <div className={styles.step}>
                        <div className={styles.stepNumber}>3</div>
                        <div className={styles.stepContent}>
                            <h3>Get Your Result</h3>
                            <p>
                                We secure your compensation from the lender's response. If they reject your claim, we
                                escalate to the Financial Ombudsman Service at no extra cost.
                            </p>
                        </div>
                    </div>
                </div>
                <p className={styles.disclaimer}>
                    <strong>Please note:</strong> You can make complaints directly to your lender yourself, and refer
                    unsuccessful complaints to the Financial Ombudsman Service for free.
                </p>
                <div className={styles.ctaCenter}>
                    <button className={styles.ctaButton} onClick={onScrollToForm}>
                        Start Your Claim Today
                    </button>
                </div>
            </div>
        </section>
    )
}
